module.exports = "/static/assets/445e1cd3c7bdfcf00df69be73de214b5.png";